import React from "react";
import SectionContainer from "../../SectionContainer/SectionContainer";
import InfoBox from "./InfoBox";
import "./sectionFour.css";

const SectionFour = () => {
  return (
    <SectionContainer whiteBG={false}>
      <div className="four-container">
        <h4>What's new</h4>
        <div className="four-row-container">
          <div className="four-row-item">
            <h3>NEW RELEASE</h3>
            <h1>Create your own character !</h1>
            <p>
              All characters look same? Now you can create your own character.
              All you need to do is select body type, hair, clothing etc from
              given choices and its done.
            </p>
          </div>
          <div className="four-row-item">
            <h3>NEW RELEASE</h3>
            <h1>Report a bug...</h1>
            <p>
              No longer you have to mail us for the bugs you face during app
              usage. You can raise issue right inside the app.
            </p>
          </div>
          <div className="four-row-item">
            <h3>NEW RELEASE</h3>
            <h1>Use tweencraft in your local language.</h1>
            <p>
              Now tweencraft is supported in local languages. As of now, we are
              supporting few of them. But soon we are going to add more
              languages. Once you select your language, you can change it any
              time.
            </p>
          </div>
        </div>
      </div>
    </SectionContainer>
  );
};

export default SectionFour;
